import React from 'react';
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/pfp.webp";
import 'animate.css';
import resume from "../assets/Gabriel_Nulman_Resume_2026.pdf";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  // eslint-disable-next-line
  const [index, setIndex] = useState(1);
  const toRotate = [
    "Backend Developer",
    "Full Stack Developer",
    "Python Developer",
    "Java Developer",
    "Discord Bot Developer",
    "Computer Vision Engineer",
    "OCR Specialist",
  ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
    // eslint-disable-next-line
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <h1>
              {`Hi, I'm Gabe — `}
              <span className="txt-rotate" dataPeriod="1000" data-rotate='[]'>
                <span className="wrap">{text}</span>
              </span>
            </h1>
            <p>
              Software Engineer specializing in backend systems and enterprise applications.
              Passionate about building efficient, scalable software — from Python-powered automation
              and Discord bots to full-stack web apps. Explore my projects and skills below.
            </p>
            <a href={resume} download="Gabriel_Nulman_Resume.pdf">
              <button className="resume-btn">Download Resume</button>
            </a>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Gabriel Nulman" width={'100%'} height={'100%'} />
          </Col>
        </Row>
      </Container>
    </section>
  )
}
